var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.385 46.77a23.384 23.384 0 110-46.77 23.384 23.384 0 010 46.77zm14.473-25.232l-2.732-2.953a3.042 3.042 0 00-2.461-.985l-4.148.32v-2.732c0-.283-.185-.48-.468-.48H10.794a.48.48 0 00-.468.48v16.357c0 .701.566 1.267 1.268 1.267h1.612c.234 1.6 1.6 2.831 3.25 2.831 1.649 0 3.064-1.23 3.249-2.83h8.394c.246 1.6 1.6 2.83 3.249 2.83s3.015-1.23 3.261-2.83h2.166c.985 0 1.785-.8 1.785-1.785V23.58c.05-.762-.234-1.476-.702-2.03v-.012zM16.444 33.76a1.415 1.415 0 111.428-1.415c0 .8-.665 1.415-1.416 1.415h-.012zm14.905 0a1.415 1.415 0 110-2.83c.8 0 1.415.664 1.415 1.415 0 .8-.615 1.415-1.415 1.415zm4.91-8.21h-6.326v-5.415l2.88-.246h.05c.184 0 .369.099.467.246l2.733 3.016c.098.148.197.283.197.43v1.97z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--delivery-a1f1c914d5f184b51530db5f1f35e912.svg";
export { SvgIconCircleDelivery as Component };